import type {CalculateParams} from '../types'
import type {CompRef, GridContainerLayout, GridItemLayout} from '@wix/document-services-types'
import {getChildrenWithoutPlugins, getLayout} from '../utils'
import {convertRowToPx} from '../converters/rows'
import {runWithRowsCalculationInProgress} from '../rowsColumnsCalculationProgress'

export const calculateRows = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, compRef, layoutData, extensionAPI} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.rows(compRef) !== undefined) {
        return
    }

    const rows = (layoutData?.containerLayout as GridContainerLayout)?.rows
    if (!rows) return

    runWithRowsCalculationInProgress(compRef.id, () => {
        const children = getChildrenWithoutPlugins(calculateParams)
        const rowToChildrenMap: Record<number, CompRef[]> = {}
        children.forEach(child => {
            const layout = getLayout(extensionAPI, child)
            const {gridArea} = layout.itemLayout as GridItemLayout
            if (!gridArea) return

            const {rowStart, rowEnd} = (layout.itemLayout as GridItemLayout).gridArea
            if (rowEnd !== rowStart + 1) return

            const rowIndex = rowStart - 1
            if (rowToChildrenMap[rowIndex]) {
                rowToChildrenMap[rowIndex].push(child)
            } else {
                rowToChildrenMap[rowIndex] = [child]
            }
        })

        const rowsInPx: number[] = []
        rows.forEach((row, index) => {
            const rowHeight = convertRowToPx[row.type]({
                ...calculateParams,
                ...row,
                rowChildren: rowToChildrenMap[index]
            })
            rowsInPx.push(rowHeight)
        })
        set.rows(compRef, rowsInPx)
    })
}
